import {
    createLocalizedTime
} from '../../react/features/speaker-stats/components/timeFunctions';
import React from 'react';

/**
 * Common methods used to help to do something
 */

export default class Helpers {

    renderCustomStats({ t, participantId }) {
        const state = APP.store.getState();
        const participant = state['wildix/features/hints'].data[participantId];

        if (!participant) {
            return null;
        }

        const time = createLocalizedTime(participant.longestMonolog || 0, t);

        return (
            <div>
                {participant && participant.longestMonolog
                    && <span>{t('speakerStats.monologue')}: {time} | </span>}
                {participant && participant.ratio !== undefined
                    && <span>{t('speakerStats.talk')}: {participant.ratio}%</span>}
            </div>
        );
    }
}
